import React, { useState } from 'react';
import Header2 from '../Header2/header2';
import Header3 from '../Header3/header3';
import Footer from '../Footer/footer';
import { Accordion, Col, Row, Form, Spinner } from 'react-bootstrap';
import axios from 'axios';
import SubmitPopup from '../Submitpopup/Submitpopup';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ReCAPTCHA from "react-google-recaptcha";
import { API_BASE_URL } from '@/config/serverApiConfig';
import {
   Card,
   CardTitle,
   CardBody,
   FormGroup,
   Label,
   Button,
   Container,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
const Aboutus = () => {

   const token = localStorage.getItem("token");

   function menu() {
      if (token === undefined || token === null) {
         return (
            <>
               <Header3 />
            </>
         )
      }
      else {
         return (
            <>
               <Header2 />
            </>
         )
      }
   }
   const [validated, setValidated] = useState(false);
   const [form, setForm] = useState({
      name: "",
      email: "",
      message: "",
      subject: "",
      phone: ""

   })
   const [phone,setPhone] = useState("");
   const [resLogin, setresLogin] = useState(
      {
         message: "",
         success: ""
      }
   );
   const [submitLoader, setSubmitLoader] = useState(false);
   const [phoneIsEmptyErr, setPhoneIsEmptyErr] = useState(false);
   let [mobileNoLength, setMobileNoLength] = useState(false);
   const [show, setShow] = useState(false);
   const [recaptchaError, setRecaptchaError] = useState(false);
   const recaptchaRef = React.useRef();
   let tokenn ='';
   async function contact_us(event) {
      event.preventDefault();

       tokenn = await recaptchaRef.current.executeAsync();
    
    if(tokenn === false  || tokenn === undefined|| tokenn === null || tokenn === ''){
      setRecaptchaError(true);
   }

      if(recap === false){
         setRecaptchaError(true);
      }
      if(phone === ""|| phone === undefined || phone === null){
         setPhoneIsEmptyErr(true);
      }
      else{
      setSubmitLoader(true);

      form.phone = phone;
      axios
         .post(`${API_BASE_URL}user/contact-us`, form)
         .then(function (response) {
            setSubmitLoader(false);
            setShow(true);
            setresLogin(response.data)

         })
         .catch(function (error) {
            setShow(true);
            setSubmitLoader(false);
            setresLogin(error.response.data)

         });
   }}
   let [recap, setRecap] = useState(false);

   function onChange(value) {
      console.log("Captcha value:", value);
      if(value){
         setRecap(true);
         setRecaptchaError(false);
      }
    }
    let [nameClass, setNameClass] = useState(true);
      let [emailClass, setEmailClass] = useState(false);
      let [messageClass, setMessageClass] = useState(false);
      let [subjectClass, setSubjectClass] = useState(false);
      let [phoneClass, setPhoneClass] = useState(false);
   function handleChange(e) {
      if(e.target.name === "phone"){
         setPhoneClass(true); 
         console.log(e.target.value);
         console.log(phoneClass);
      }
      if(e.target.name === "name"){
         setNameClass(true);
         console.log(e.target.value);
         console.log(nameClass);
      }
      if(e.target.name === "email"){
         setEmailClass(true);
      }
      if(e.target.name === "message"){
         setMessageClass(true);
      }

     
      setForm({
         ...form,
         [e.target.name]: e.target.value
      });
   }

   return (
      <>
         {menu()}
         <SubmitPopup
            onClose={() => setShow(false)}
            show={show}
            title={resLogin.message}
         />
         <section className='about-us-page min-height-g'>
            <div className="container-fluid about_banner_bg">
               <div className='container d-flex align-items-center'>
                  <h2 className="mb-0">About <span className='color-9F7854'><strong> Us</strong></span></h2>
               </div>
            </div>
            <div className='container-fluid bg-white'>
               <div className="container">
                  <div className='row'>
                     <div className="col text-center py-5">
                        <h2 className="h2_medum fw-bold" >Mission & Vision</h2>
                        <p>Khoja Business Directory is a nonprofit initiative by the community leaders for the community. The aim is to create a secure repository of all Khoja-led businesses around the globe by crowdsourcing the business details from the community itself. In this way, no community business will be left behind.</p>
                        <p>The platform is built using state-of-the-art technology and data security and privacy strategies and tools to ensure the safety of the data. It is also fully GDPR compliant and has a dynamic team of admins and moderators verifying member identities and business details.</p>
                        <p>Help us reach out to the community by signing up and listing the businesses you know!</p>
                     </div>
                  </div>
               </div>
            </div>
            <div className='container-fluid pb-5'>
               <div className="container">
                  <div className='row'>
                     <div className="col text-center py-5">
                        <h2 className="h2_medum fw-bold pt-4" >FAQs</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                     </div>
                  </div>
                  <div className="row">
                     <Accordion defaultActiveKey={['0']}>
                        <Accordion.Item eventKey="0" className='mb-4'>
                           <Accordion.Header>
                              <span className='count'>01.</span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Ut enim ad minim veniam, quis nostrud exercitation ullamco?</Accordion.Header>
                           <Accordion.Body>
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                              veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                              commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                              velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                              cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
                              est laborum.
                           </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1" className='mb-4'>
                           <Accordion.Header>
                              <span className='count'>02.</span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Ut enim ad minim veniam, quis nostrud exercitation ullamco?</Accordion.Header>
                           <Accordion.Body>
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                              veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                              commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                              velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                              cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
                              est laborum.
                           </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2" className='mb-4'>
                           <Accordion.Header>
                              <span className='count'>03.</span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Ut enim ad minim veniam, quis nostrud exercitation ullamco?</Accordion.Header>
                           <Accordion.Body>
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                              veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                              commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                              velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                              cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
                              est laborum.
                           </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3" className='mb-4'>
                           <Accordion.Header>
                              <span className='count'>04.</span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Ut enim ad minim veniam, quis nostrud exercitation ullamco?</Accordion.Header>
                           <Accordion.Body>
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                              tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                              veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                              commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                              velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                              cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
                              est laborum.
                           </Accordion.Body>
                        </Accordion.Item>
                     </Accordion>
                  </div>
               </div>
            </div>
            <div className='container-fluid contact_sec mt-5 d-flex align-items-center'>
               <div className='container '>
                  <div className='row'>
                     <div className='col-lg-6'>
                     </div>
                     <div className='col-lg-6' style={{ zIndex: '2' }}>
                        <h2 className="h2_medum fw-bold" >Get In Touch</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        <Row>

                           <AvForm onValidSubmit={contact_us} >
                              <Row>
                                 <Col lg={6}>
                                    <FormGroup className={nameClass ? "mb-4 active":"mb-4"}>
                                       <Label className={nameClass ? "active" : ""} >Name *</Label>
                                       <AvField
                                          type="text"
                                          validate={{
                                             pattern: {
                                                value: /^[a-zA-Z ]+$/,
                                                errorMessage: "Only Alphabet are allowed",
                                             },
                                             required: {
                                                required: true,
                                                errorMessage: "Enter Name",
                                             },
                                          }} className='form-control border-0 border-bottom bg-transparent'
                                          onChange={handleChange} name="name" />

                                    </FormGroup>
                                 </Col>
                                 <Col lg={6}>
                                    <FormGroup className= "mb-4">
                                       <Label>Email Address *</Label>
                                       <AvField type="email"
                                          validate={{
                                             pattern: {
                                                value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                                errorMessage: "Enter Valid Email Address",
                                             },
                                             required: {
                                                value: true,
                                                errorMessage: "Email Address is Required",
                                             },
                                          }}
                                          className='form-control border-0 border-bottom bg-transparent' name="email" onChange={handleChange} />
                                    </FormGroup>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col lg={6}>
                                    <FormGroup className="mb-4">
                                       <Label type="number">Phone Number *</Label>
                                       <PhoneInput
                                          inputClass="form-control border-0 border-bottom bg-transparent"
                                          id="phone"
                                          country={'pk'}
                                          placeholder=""
                                          rules={{ required: true }} 
                                          name="phone"
                                          value={phone}
                                          
                                          onChange={(value, country, e) => {
                                             setPhoneClass(true); 
                                             setNameClass(false)
                                             setEmailClass(false)
                                             setSubjectClass(false)
                                             setMessageClass(false)
                                            setPhoneIsEmptyErr(false);
                                            setMobileNoLength( country.format?.split(".").length - 1); 
                                            setPhone(value); }} 
                                             onBlur={(e, country) => {
                                                let _length = country.format?.split(".").length - 1;
                                                if (phone.length !== _length) { 
                                                  setPhoneIsEmptyErr(true); 
                                                  autoFocus: true
                                              }
                                            else {
                                              setPhoneIsEmptyErr(false); 
                      
                                            } }} 
                                       />
                                       {phoneIsEmptyErr ? (
                      <span className="error-msg">Please enter a valid phone number</span>
                    ) : (
                      ""
                    )}
                                       {/* <AvField type="text"
                                          validate={{
                                             required: {
                                                required: true,
                                                errorMessage: "Phone Number is required",
                                             },
                                          }}
                                          className='form-control border-0 border-bottom bg-transparent' name="phone" onChange={handleChange} /> */}
                                    </FormGroup>
                                 </Col>
                                 <Col lg={6}>
                                    <FormGroup className="mb-4">
                                       <Label>Subject *</Label>
                                       <AvField
                                          validate={{
                                             required: {
                                                required: true,
                                                errorMessage: "Subject is required",
                                             },
                                          }}
                                          className='form-control border-0 border-bottom bg-transparent' name="subject" type="text" onChange={handleChange} />
                                    </FormGroup>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col>
                                    <FormGroup className="mb-3">
                                       <Label>Message</Label>
                                       <AvField as="textarea"
                                          className='orm-control border-0 border-bottom bg-transparent'
                                          rows={3}
                                          style={{ height: "100px", resize: "none" }}
                                          name="message"
                                          onChange={handleChange}
                                          type="text"
                                          validate={{
                                             required: {
                                                required: true,
                                                errorMessage: "Message is required",
                                             },
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              </Row>
                              <Row >
                                 <Col>

                                    <Button className={submitLoader ? "btn-full-color float-end mt-4 disable" : "btn-full-color float-end mt-4"} type="submit">
                                       <Spinner
                                          as="span"
                                          animation={submitLoader ? 'border' : ''}
                                          size="sm"
                                          role="status"
                                          aria-hidden="false"
                                       />   Submit
                                    </Button>
                                 </Col>
                              </Row>
                              
                              {
                                 recaptchaError ? (
                                    <span className="error-msg">Please verify that you are not a robot</span>
                                 ) : (
                                    ""
                                 )

                              }
                           </AvForm>
      
                        </Row>
                        <ReCAPTCHA
                                sitekey="6LfXbVggAAAAAF20tZ9IMRYPIeWhnPJ3QJ12c1Bf"
                                ref={recaptchaRef}
        size="invisible"
                              />
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <Footer />
      </>
   )
}
export default Aboutus;